import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';
import type { VersionId } from '../../../common/model/index.tsx';
import type { SwapVersionsPayload } from './types.tsx';

export const deleteAndSwapVersionUrl = (id: VersionId): string =>
	`/rest/api/2/version/${id}/removeAndSwap`;

export const deleteAndSwapVersion = async (
	versionId: VersionId,
	swap: SwapVersionsPayload,
): Promise<void> => {
	const url = deleteAndSwapVersionUrl(versionId);
	const response = await fetch(url, {
		...getDefaultOptions(url),
		method: 'POST',
		body: JSON.stringify(swap),
	});

	if (response.ok) {
		return;
	}

	const text = await response.text();
	throw new FetchError(response.status, text);
};
